import React, { useCallback } from 'react'
import { errorLogger, updateAppAlert } from '@labrav/common'
import { useDispatch, useSelector } from '../../../store'

export type CopyToClipboardType = {
  children: React.ReactElement
  data: string
  successMessage: string
  failureMessage: string
  isClickable?: boolean
}

export const CopyToClipboard = React.memo(
  ({
    data,
    children,
    isClickable,
    successMessage,
    failureMessage,
  }: CopyToClipboardType) => {
    const dispatch = useDispatch()
    const globalState = useSelector(state => state)
    const copyToClipboard = useCallback(() => {
      navigator.clipboard
        .writeText(data)
        .then(() =>
          dispatch(
            updateAppAlert({
              message: successMessage,
              messageType: 'SUCCESS',
              autoClose: true,
            })
          )
        )
        .catch(() => {
          dispatch(
            updateAppAlert({
              message: failureMessage,
              messageType: 'ERROR',
              autoClose: true,
            })
          )
          const error: Error = {
            name: 'Clipboard error',
            message: failureMessage,
          }
          errorLogger({ globalState })(error as Error)
        })
    }, [data, dispatch, failureMessage, globalState, successMessage])

    return (
      <div
        onClick={isClickable ? copyToClipboard : undefined}
        data-testid="clipboard"
      >
        {children}
      </div>
    )
  }
)
